import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { isOpen: false };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleGlobalClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleGlobalClick, true);
    }

    render() {
        return (
            <tooltip
                onClick={this.toggle}
                className={this.state.isOpen ? 'is-open' : ''}
                ref={el => this.el = el}
            >
                {this.renderText()}
                <icon />
                {this.renderContent()}
            </tooltip>
        );
    }

    renderText = () => {
        if (this.props.text) {
            return (
                <a className='has-padding-10-right'>{this.props.text}</a>
            );
        }

        return null;
    }
    renderContent = () => {
        if (this.props.content && this.state.isOpen) {
            return (
                <div className='tooltip-content'>
                    {this.renderContentData()}
                </div>
            );
        }

        return null;
    }

    renderContentData = () => {
        if (_.isArray(this.props.content)) {
            return this.props.content.map(p => <p dangerouslySetInnerHTML={{__html: p}} />);
        }

        return (<p dangerouslySetInnerHTML={{__html: this.props.content}} />);
    }

    toggle = () => {
        if (this.props.text && !this.state.isOpen) {
            this.props.trackEvent([
                'Site Interaction',
                `${this.props.logged_in ? 'LI' : 'LO'} Click`,
                `Time-Unknown-Link-${this.props.location}`,
            ]);
        }

        this.setState({ isOpen: !this.state.isOpen });
    }

    handleGlobalClick = (e) => {
        if (this.state.isOpen && e.target != this.el && !this.el.contains(e.target)) {
            this.setState({ isOpen: !this.state.isOpen });
        }
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
